<template>
  <v-app-bar class="modern-navbar" absolute>
    <v-app-bar-title class="navbar-title">
      Team Practice Plan
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <!-- Navigation Links -->
    <div class="navbar-links" v-if="!isSharedView">
      <v-btn 
        :to="{ name: 'home' }" 
        variant="text" 
        class="navbar-btn"
        :class="{ 'active': $route.name === 'home' }"
      >
        <v-icon class="me-2">mdi-home</v-icon>
        Home
      </v-btn>
      
      <v-btn 
        :to="{ name: 'planedit', params: { id: 'new' } }" 
        variant="text" 
        class="navbar-btn"
        :class="{ 'active': $route.name === 'planedit' && $route.params.id === 'new' }"
      >
        <v-icon class="me-2">mdi-plus</v-icon>
        New Practice Plan
      </v-btn>

      <v-btn 
        :to="{ name: 'drilllibrary' }" 
        variant="text" 
        class="navbar-btn"
        :class="{ 'active': $route.name === 'drilllibrary' }"
      >
        <v-icon class="me-2">mdi-library</v-icon>
        Drill Library
      </v-btn>

      <!-- Teams Dropdown -->
      <v-menu v-if="user.teams && user.teams.length > 0">
        <template v-slot:activator="{ props }">
          <v-btn 
            v-bind="props" 
            variant="text" 
            class="navbar-btn"
            :class="{ 'active': $route.name === 'teamedit' }"
          >
            <v-icon class="me-2">mdi-account-group</v-icon>
            Teams
            <v-icon class="ms-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        
        <v-list class="teams-menu">
          <v-list-item 
            v-for="team in user.teams" 
            :key="team.id"
            :to="{ name: 'teamedit', params: { id: team.id } }"
            class="team-menu-item"
          >
            <v-list-item-title>{{ team.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <!-- User Info -->
    <div class="user-info" v-if="!isSharedView && user.name">
      <v-avatar size="32" class="me-2">
        <v-icon>mdi-account</v-icon>
      </v-avatar>
      <span class="user-name">{{ user.name }}</span>
    </div>
  </v-app-bar>
</template>

<script>
import {ref} from 'vue';
import {currentUserStore} from '../stores/currentUserStore'

export default {
  name: 'PageHeader',
  data() {
    return {
      user: ref({}),
      isSharedView: false,
    }
  },
  mounted() {
    let self = this;
    this.user = currentUserStore().currentUser;

    currentUserStore().$subscribe(() => {
      self.user = currentUserStore().currentUser;
    });
  },
  created() {
    this.$watch(
        () => {
          this.isSharedView = this.$route.name === "sharedview";
        },
        () => {
          this.isSharedView = this.$route.name === "sharedview";
        },
        {immediate: true}
    )
  },

}
</script>

<style scoped>
/* Modern navbar styling */
.modern-navbar {
  background: linear-gradient(270deg, rgba(48,53,101,1) 0%, rgba(148,75,211,1) 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
}

.navbar-title {
  font-weight: 700 !important;
  color: white !important;
  font-size: 1.3rem !important;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.navbar-btn {
  border-radius: 0px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease !important;
}

.navbar-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
}

.navbar-btn.active {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  font-weight: 600 !important;
}

.user-info {
  display: flex;
  align-items: center;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.user-name {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

.teams-menu {
  border-radius: 0px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.team-menu-item {
  border-radius: 0px !important;
  transition: all 0.2s ease !important;
}

.team-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .navbar-links {
    gap: 4px;
  }
  
  .navbar-btn {
    font-size: 0.8rem !important;
    padding: 8px 12px !important;
  }
  
  .navbar-btn .v-icon {
    font-size: 1rem !important;
  }
  
  .user-info {
    margin-left: 8px;
    padding-left: 8px;
  }
  
  .user-name {
    display: none;
  }
}

@media (max-width: 600px) {
  .navbar-btn span {
    display: none;
  }
  
  .navbar-btn .v-icon {
    margin: 0 !important;
  }
}

/* Legacy styles for compatibility */
header {
  margin-bottom: 75px;
}

.team-item {
  margin-left: 10px;
  list-style: none;
}
</style>
    